var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "q-toolbar" }, [
        _c(
          "div",
          { staticClass: "q-toolbar-buttons" },
          [
            _c("q-label", {
              attrs: { width: "200" },
              model: {
                value: _vm.trusted.caption,
                callback: function ($$v) {
                  _vm.$set(_vm.trusted, "caption", $$v)
                },
                expression: "trusted.caption",
              },
            }),
            _vm._v(" "),
            _c(
              "q-input",
              {
                style: _vm.searchStyle,
                attrs: {
                  placeholder: this.$qt("listStructure.searchPlaceHolder"),
                },
                model: {
                  value: _vm.word,
                  callback: function ($$v) {
                    _vm.word = $$v
                  },
                  expression: "word",
                },
              },
              [
                _c("q-button", {
                  attrs: {
                    slot: "append",
                    type: "info",
                    icon: "q-icon-search",
                  },
                  slot: "append",
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                on: { click: _vm.updatePermission },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "save"] } })],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "q-table",
        {
          attrs: {
            stripe: "",
            border: "",
            data: _vm.filteredData,
            width: "100%",
            "sum-text": "----",
            "empty-text": this.$qt("listStructure.emptyList"),
          },
        },
        [
          _c("q-table-column", {
            attrs: {
              prop: "caption",
              label: this.$qt("permission.editor.captionColumnText"),
            },
          }),
          _vm._v(" "),
          _c("q-table-column", {
            attrs: {
              width: "100",
              label: this.$qt("permission.editor.isGrant"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "q-toolbar-buttons" },
                      [
                        _c("q-checkbox", {
                          model: {
                            value: scope.row.grant,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "grant", $$v)
                            },
                            expression: "scope.row.grant",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm._l(_vm.permissions, function (permission) {
            return _c("q-table-column", {
              key: permission.key,
              attrs: { label: permission.caption, width: "70" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        [
                          _c("q-checkbox", {
                            model: {
                              value: scope.row[permission.key],
                              callback: function ($$v) {
                                _vm.$set(scope.row, permission.key, $$v)
                              },
                              expression: "scope.row[permission.key]",
                            },
                          }),
                        ],
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }